/* eslint-disable arrow-body-style */

/**
 * REMARK: 注释解释1
 * 游戏详情页Project Update tab页签，暂时移除progress信息
 * 代码没删除，只把相关的代码注释了，后面需要重新加上progress的信息，把带有注释解释1的代码 解开注释即可
 */
import React, { useRef, useMemo, useState, useEffect } from 'react';
// import classnames from 'classnames';
import moment from 'moment';
import { useSelector, useDispatch } from 'umi';
import {
  useRequest,
  useAsyncEffect,
  useUpdateEffect,
  useMemoizedFn,
  useDeepCompareEffect,
} from 'ahooks';
import { Bubble, Segment } from 'tea-component';
import HomeSvgIcon from '@/pages/home/components/SvgIcon';
// import SvgIcon from '@gp/components/Iconfont';
import Loading from '@gp/components/Loading';
import NoData from '@gp/components/NoData';
import GeneralModal from '@gp/components/GeneralModal';
import Filter from '@gp/pages/Pipeline/ProjectDetails/ProjectUpdate/components/Filter';
import ActionItemsFilter from '@gp/pages/Pipeline/ProjectDetails/ProjectUpdate/components/ActionItemsFilter';
import ActionItemsList from '@gp/pages/Pipeline/ProjectDetails/ProjectUpdate/components/ActionItemsList';
// import UpdateFrequencyModal from '@gp/pages/Pipeline/ProjectDetails/ProjectUpdate/components/UpdateFrequencyModal';
import ProjectUpdateCard from './components/ProjectUpdateCard';
import UpdateProjectEditForm, {
  IUpdateProjectEditFormInstance,
} from './components/UpdateProjectEditForm';
import { context } from '@gp/components/Context/index';
import useLoadMoreUpdates from './_hooks/useLoadMoreUpdates';
import useAutoScroll2Target from './_hooks/useAutoScroll2Target';
// import useRenewableFrequency from '@gp/pages/Pipeline/ProjectDetails/hook/useRenewableFrequency';
// REMARK: 参考 src/pages/Pipeline/ProjectDetails/ProjectUpdate/index.tsx文件头部的注释解释1
// import { DETAIL_PROGRESS_TAG_MODEL_NAMESPACE, IDetailProgressTagState } from '@gp/models/detailProgressTag';
import {
  GAME_DETAIL_TAB_DATA_MODEL_NAMESPACE,
  IGameDetailTabDataState,
} from '@gp/models/gameDetailTabData';
import {
  queryGuideInfo,
  updateGuide,
  reportOperationLog,
  getBIDSTencentQCouldMassage,
} from '@gp/services/global';
import {
  queryProjectUpdateList as queryProjectUpdateListOriginal,
  editProjectUpdate as editProjectUpdateOriginal,
  // deleteProjectUpdate,
  queryActionItemsList as queryActionItemsListOriginal,
} from '@gp/services/projectUpdate';
import { messageTips, handleRisksCategory, addIdBatch } from '@gp/utils/common';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import {
  getMaxLength,
  formatGRActionItemsRes,
  formatGRActionItemsReq,
  scrollUpdatesCardIntoView,
  getValidList,
  getValidActionItems,
} from './utils';
import {
  G_POP_PAGE_PROJECT_UPDATE_FULL_ACTION_ITEMS_LIST,
  StaticActionItemCodes,
  UPLOAD_FOLDER_NAME_MAP } from '@gp/constants/const';
import { ALL_REPORT_OPERATION_LOG } from '@gp/constants/operationLogParams';
import {
  SEGMENT_UPDATE_INFO,
  SEGMENT_ACTION_ITEMS_LIST,
  DURATION,
  AUTO_SCROLL_WAITTING,
} from './constants';
import { useAutoSaveParams, EDIT_PAGE_KEY_MAP } from '@gp/hooks/useAutoSaveParams';
import AutoSaveModal from '@gp/components/AutoSaveModal';
import type { IBaseProps } from '@home/types/common';
import type { SortBy } from 'tea-component/lib/table/addons';
import useCos from '@gp/hooks/useCos';
import './index.scss';

interface IactionItemsListDownloadParams {
  selectDate: [string, string];
  sorts: SortBy<any>;
  selectStatus: string[];
  selectPhase: string[];
}

interface IProjectUpdateProps extends IBaseProps {
  pageContainer?: React.RefObject<HTMLElement | null>;
  userIsAbleSee?: boolean;
  userIsAbleEdit: boolean;
  filterObj: any;
  projectDetailData: any;
  milestones: any[] | null;
  hideHeader?: boolean;
  // onUpdateRenewableFrequencySuccess?: () => void;
  onRefreshProjectDetails?: () => any;
  onRefreshMilestones?: () => void;
}

const currentUserName = storage.getSessionStorageItem('userName');

const ADD_DEFAULT_ITEM = {
  // uniqueId: 0,
  // is_add_item: true, // 用于识别当前是添加的数据
  date: '',
  granularity: 2, // 1：月，2：周
  // progress: 0,
  update_time: '', // 当天时间
  update_user: '', // 名字要填当前人员的
  content: {
    key_updates: '',
    risks: null,
    workplans: null,
  },
  gr_action_milestone_id: '',
  gr_action_milestone: '',
  gr_action: [],
  material: [],
};

const ACTION_ITEMS_LIST_DEFAULT_DOWNLOAD_PARAMS: IactionItemsListDownloadParams = {
  selectDate: ['', ''],
  sorts: {
    by: 'due_date',
    order: 'asc',
  },
  selectStatus: ['1', '2', '3'],
  selectPhase: [],
};

const DEFAULT_FILTER_OBJ = {};

const queryProjectUpdateList = async (
  ...params: Parameters<typeof queryProjectUpdateListOriginal>
): Promise<any> => {
  const res = await queryProjectUpdateListOriginal(...params);
  const resData = res?.data || {};
  const list = resData?.data || [];
  const listTmp = list?.map((item: any) => {
    const { content, gr_action: grActionItems, ...restItem } = item || {};
    const { workplans, ...restContent } = content || {};
    const contentTmp = { ...restContent, workplans: addIdBatch(workplans) };
    return { ...restItem, content: contentTmp, gr_action: formatGRActionItemsRes(grActionItems) };
  });
  return { ...res, data: { ...resData, data: listTmp } };
};

const queryActionItemsList = async (
  ...params: Parameters<typeof queryActionItemsListOriginal>
): Promise<any> => {
  const res = await queryActionItemsListOriginal(...params);
  const resData = res?.data || {};
  const { workplans, ...restResData } = resData?.data || {};
  const workplansTmp = workplans?.map((workplan: any) => {
    const { status, ...restWorkplan } = workplan || {};
    return { ...restWorkplan, status: getWorkplanStatusRes(workplan) };
  });
  const resDataTmp = { ...restResData, workplans: workplansTmp };
  return { ...resData, data: { ...resData, data: resDataTmp } };
};

const editProjectUpdate = async (params: any): ReturnType<typeof editProjectUpdateOriginal> => {
  const { gr_action: grActionItems } = params || {};
  const paramsTmp = {
    ...params,
    gr_action: formatGRActionItemsReq(grActionItems),
  };
  return editProjectUpdateOriginal(paramsTmp);
};

const getWorkplanStatusRes = (payload?: any): any => {
  const { status, completed } = payload || {};
  if (status || !Reflect.has(payload || {}, 'completed')) return String(status);
  return completed ? StaticActionItemCodes.Completed : StaticActionItemCodes.NotStarted;
};

const handleWorkplansRes = (list?: any[]): any[] => {
  if (!Array.isArray(list) || !list.length) return [];
  return list.map((item) => {
    const statusTmp = getWorkplanStatusRes(item);
    return { ...item, status: statusTmp };
  });
};

const ProjectUpdate: React.FC<IProjectUpdateProps> = (props) => {
  const {
    pageContainer,
    userIsAbleSee,
    userIsAbleEdit = false,
    filterObj = DEFAULT_FILTER_OBJ,
    projectDetailData = null,
    milestones = null,
    hideHeader = false,
    // onUpdateRenewableFrequencySuccess,
    onRefreshProjectDetails,
    onRefreshMilestones,
    actionItemCategory,
  } = props;

  const dispatch = useDispatch();

  const { filter } = useSelector<any, IGameDetailTabDataState>(
    (state) => state?.[GAME_DETAIL_TAB_DATA_MODEL_NAMESPACE] || {},
  );

  const { deleteObject } = useCos({ qCouldService: getBIDSTencentQCouldMassage, qCouldServiceParams: UPLOAD_FOLDER_NAME_MAP.updatesMaterial });

  const [segmentValue, setSegmentValue] = useState<'1' | '2'>(SEGMENT_UPDATE_INFO);
  const [bubbleVisible, setBubbleVisible] = useState<boolean>(false);
  const [isCompletedSegmentGuide, setIsCompletedSegmentGuide] = useState<boolean>(false);
  const [isCompletedVideo, setIsCompletedVideo] = useState<boolean>(true);
  // const [updateFrequencyVisible, setUpdateFrequencyVisible] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [formModelMilestone, setFormModelMilestone] = useState<string>(''); // 受update info页面milestone筛选器影响的milestone
  // 新增、编辑ProjectUpdate表单组件实例
  const updateProjectEditForm = useRef<IUpdateProjectEditFormInstance | null>(null);
  // 新增、编辑的loading
  const [editLoading, setEditLoading] = useState(false);
  // 新增、编辑的表单是否点过Confirm（从上次点Confirm掉接口后开始算）
  const [submitted, setSubmitted] = useState(false);
  // 新增、编辑的表单校验 是否有填写内容
  const [editAvailable, setEditAvailable] = useState(false);
  // 新增、编辑的表单校验 是否校验合法
  const [editValid, setEditValid] = useState(false);
  // 新增或编辑状态
  const [mode, setMode] = useState<'add' | 'edit' | ''>('');
  // 编辑弹窗显示、隐藏
  const [editModalVisible, setEditModalVisible] = useState<boolean>(false);
  const [currentEditList, setCurrentEditList] = useState<any>(null);

  // 提交时，要删除的云文件
  const [deletePathList, setDeletePathList] = useState<any[]>([]);

  const deleteFileFun = async () => {
    const deFunList = deletePathList?.map((path: string) => {
      return deleteObject({ path });
    });
    Promise.all(deFunList).then(() => {});
  };

  const resetAddEditData = useMemoizedFn(() => {
    setMode('');
    setCurrentEditList(null);
    setEditModalVisible(false);
    setSubmitted(false);
  });

  /* const { frequencyLabel } = useRenewableFrequency({
    milestones,
    milestone: formModelMilestone,
  });

  const milestoneId = useMemo(() => {
    const target = milestones?.find(
      (item: any) => item?.value === formModelMilestone,
    );
    return target?.milestone_id || '';
  }, [formModelMilestone, milestones]);

  const handleUpdateFrequency = useMemoizedFn(() => {
    if (!userIsAbleEdit) return;
    setUpdateFrequencyVisible(true);
  });

  const handleUpdateFrequencySuccess = useMemoizedFn(() => {
    onUpdateRenewableFrequencySuccess?.();
  }); */

  // 页面打点
  useEffect(() => {
    if (['1', '2']?.includes(segmentValue)) {
      // @ts-ignore
      reportOperationLog({
        ...ALL_REPORT_OPERATION_LOG[
          segmentValue === SEGMENT_UPDATE_INFO
            ? 'PIPELINE_DETAIL_PROJECT_UPDATE'
            : 'PIPELINE_DETAIL_PROJECT_UPDATE_ACTION_LIST'
        ],
        uidType: 'game_code',
        uid: projectDetailData?.project_id || '',
        extInfo: projectDetailData?.name,
      });
    }
  }, [segmentValue]);

  // #region Update Info页面相关
  // 区分loading效果
  const [isInit, setIsInit] = useState<boolean>(true);
  const [dataList, setDataList] = useState<any>([]);
  // 默认数据中每个卡片Confirm按钮是否可以用，可用为true
  const [defaultDataConfirmAccessList, setDefaultDataConfirmAccessList] = useState<boolean[]>([]);
  // 默认数据中每个卡片是否进入编辑态，进入编辑态为true
  const [defaultDataCardStatusList, setDefaultDataCardStatusList] = useState<boolean[]>([]);
  const [addDataList, setAddDataList] = useState<any>(null);
  // 添加的数据中每个卡片Confirm按钮是否可以用，可用为true
  const [addDataConfirmAccessList, setAddDataConfirmAccessList] = useState<boolean[]>([]);
  // 添加的数据中每个卡片是否进入编辑态，进入编辑态为true
  const [addDataCardStatusList, setAddDataCardStatusList] = useState<boolean[]>([]);
  // 根据defaultDataConfirmAccessList和addDataConfirmAccessList的情况判断Add Updates按钮是否要禁用
  const [disabledAddBtn, setDisabledAddBtn] = useState<boolean>(false);
  const [selectMilestone, setSelectMilestone] = useState<string[] | null>(null);
  // 标记当前选中的milstone是否是接口返回选中的，避免重复请求接口
  // const [isResponseMilestone, setIsResponseMilestone] = useState<boolean>(false);
  const [selectCategory, setSelectCategory] = useState<string>('all');
  const [contentLoading, setContentLoading] = useState<boolean>(true);
  const filterRef = useRef<any>(null);
  // 是否编辑态已经打点了，没有离开页面的情况
  const [isReportOperationLoged, setIsReportOperationLoged] = useState<boolean>(false);

  const selectMilestoneId = useMemo(() => {
    if (!Array.isArray(milestones) || !Array.isArray(selectMilestone)) return '';
    const selectMilestoneIds: string[] = [];
    for (let i = 0;i < selectMilestone?.length;i++) {
      const t = selectMilestone?.[i];
      selectMilestoneIds.push(milestones?.find((item) => item.value === t)?.milestone_id || '');
    }

    return selectMilestoneIds?.join(',');
  }, [selectMilestone, milestones]);

  const {
    data: projectUpdateList,
    loading: projectUpdateLoading,
    run: projectUpdateRun,
  } = useRequest(queryProjectUpdateList, { manual: true });

  const { loading: segmentGuideLoading } = useRequest(queryGuideInfo, {
    defaultParams: [{ page: G_POP_PAGE_PROJECT_UPDATE_FULL_ACTION_ITEMS_LIST }],
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onSuccess: async (res) => {
      const isCompletedSegmentGuide = !res;
      setIsCompletedSegmentGuide(isCompletedSegmentGuide);
      // 首次访问后，自动更新为已访问
      if (!isCompletedSegmentGuide) {
        await updateGuide({
          page: G_POP_PAGE_PROJECT_UPDATE_FULL_ACTION_ITEMS_LIST,
        });
      }
    },
  });

  const handleClickCloseGuide = useMemoizedFn(async (e: any) => {
    try {
      e?.stopPropagation();
      setBubbleVisible(false);
      setIsCompletedSegmentGuide(true);
      /* if (res.code === 200 || res.code === 0) {
        setBubbleVisible(false);
        setIsCompletedSegmentGuide(true);
      } */
    } catch (error) {}
  });

  // 是否显示segment引导
  useEffect(() => {
    if (segmentGuideLoading) return;
    if (isCompletedSegmentGuide) return;
    setBubbleVisible(true);
  }, [segmentGuideLoading, isCompletedSegmentGuide]);

  // 已有的updation日期，即update卡片title的日期
  const selectedUpdationDates = useMemo(() => {
    const data = projectUpdateList?.data?.data;
    if (!Array.isArray(data)) return [];
    return data.filter((item: any) => item?.date).map((item: any) => item?.date) || [];
  }, [projectUpdateLoading]);

  // 点击Add Updates添加按钮
  const handleFilterAdd = () => {
    if (disabledAddBtn) return;
    const addItem = { ...ADD_DEFAULT_ITEM };
    // addItem.uniqueId = Date.now();
    addItem.update_time = moment().format('YYYY-MM-DD HH:mm:ss');
    addItem.update_user = currentUserName;
    // const newAddDataList =
    //   /* addDataList?.length ? [addItem, ...addDataList] :  */ [addItem];
    // setAddDataList(newAddDataList);
    // setAddDataConfirmAccessList([false /* , ...addDataConfirmAccessList */]);
    // setAddDataCardStatusList([false /* , ...addDataCardStatusList */]);
    setMode('add');
    setCurrentEditList(addItem);

    // 如果有自动保存过的，先咨询
    if (
      showRestorePrompt(
        `${EDIT_PAGE_KEY_MAP.pipeline_gameDetails_update_info_add}_${projectDetailData?.project_id}`,
      )
    ) {
      setAutoSaveVisible(true);
    } else {
      setEditModalVisible(true);
    }
    // setEditModalVisible(true);
  };

  // 点击Add Updates按钮后，如果添加的数据大于一条删除前一项数据
  const removeAddListLastItem = () => {
    if (addDataList?.length > 1) {
      const v = addDataList?.filter((_: any, i: number) => i !== addDataList?.length - 1);
      setAddDataList(v);
    }
    if (addDataConfirmAccessList?.length > 1) {
      const v = addDataConfirmAccessList?.filter(
        (_: any, i: number) => i !== addDataConfirmAccessList?.length - 1,
      );
      setAddDataConfirmAccessList(v);
      const v2 = addDataCardStatusList?.filter(
        (_: any, i: number) => i !== addDataCardStatusList?.length - 1,
      );
      setAddDataCardStatusList(v2);
    }
  };

  const handleFilterChange = (payload: any, filterName: string) => {
    filterName === 'milestone' && setSelectMilestone([...payload?.milestone]);
    // setIsResponseMilestone(false);
    filterName === 'category' && setSelectCategory(payload?.category);
  };

  // 点击卡片的delete按钮
  const handleDeleteCard = (type: 'add' | 'default', position: number) => {
    if (type === 'add') {
      const newAddDataList = addDataList?.filter((_: any, i: number) => i !== position);
      setAddDataList(newAddDataList);
      const _accessList = addDataConfirmAccessList?.filter((_: any, i: number) => i !== position);
      setAddDataConfirmAccessList(_accessList);
      const v = addDataCardStatusList?.filter((_: any, i: number) => i !== position);
      setAddDataCardStatusList(v);
    } else {
      const newDataList = dataList?.filter((_: any, i: number) => i !== position);
      setDataList(newDataList);
      // 判断各模块卡片编辑态Confirm按钮是否可用
      const _accessList = newDataList?.map((t: any) => {
        {
          /*/ / REMARK: 参考 src/pages/Pipeline/ProjectDetails/ProjectUpdate/index.tsx文件头部的注释解释1
        return (t?.date && t?.progress) ? true : false;*/
        }

        return !!t?.date;
      });
      setDefaultDataConfirmAccessList(_accessList);
      const v = defaultDataCardStatusList?.filter((_: any, i: number) => i !== position);
      setDefaultDataCardStatusList(v);
    }
  };

  // 编辑后重新请求数据
  const resetQueryList = (type: 'add' | 'default') => {
    // 数据删除成功后重新请求数据，以便展示对应条数
    projectUpdateRun({
      project_id: projectDetailData?.project_id || '',
      // milestone_id: selectMilestoneId,
      // current_milestone_id: projectDetailData?.current_milestone_id,
    });
    if (!isReportOperationLoged) {
      if (type === 'add') {
        setAddDataList?.(null);
        /* reportOperationLog({
          ...ALL_REPORT_OPERATION_LOG['PIPELINE_DETAIL_PROJECT_UPDATE_ADD'],
          uidType: 'game_code',
          uid: projectDetailData?.name,
        }); */
      } else {
        /* reportOperationLog({
          ...ALL_REPORT_OPERATION_LOG['PIPELINE_DETAIL_PROJECT_UPDATE_EDIT'],
          uidType: 'game_code',
          uid: projectDetailData?.name,
        }); */
      }
      setIsReportOperationLoged(true);
    }
  };

  useEffect(() => {
    // 页面打点
    // reportOperationLog({
    //   ...ALL_REPORT_OPERATION_LOG.PIPELINE_DETAIL_PROJECT_UPDATE,
    //   uidType: 'game_code',
    //   uid: projectDetailData?.name,
    // });

    return () => {
      setIsReportOperationLoged(false);
    };
  }, []);

  // 判断Add Updates按钮是否要禁用
  useEffect(() => {
    const flag1 = defaultDataCardStatusList?.some((t: boolean) => t);
    const flag2 = addDataCardStatusList?.some((t: boolean) => t);
    setDisabledAddBtn(flag1 || flag2);
  }, [defaultDataCardStatusList, addDataCardStatusList]);

  useEffect(() => {
    // 详情页接口还没返回数据时不请求接口
    if (!projectDetailData?.project_id || !selectMilestone) return;
    // 当是接口选中的milstone不请求接口
    // if (isResponseMilestone) return;
    // 当详情页点击milestone列表跳转过来时，selectMilestone还没有值的话不请求接口
    /* if (
      (filter?.milestone && !selectMilestone)
      || (filterObj?.projectUpdateInitMilestone && !selectMilestone) // 地址栏跳转过来时
    ) return; */
    setAddDataList(null);
    setAddDataCardStatusList([]);
    projectUpdateRun({
      project_id: projectDetailData?.project_id,
      // milestone_id:
      //   /* (isInit && !filter?.milestone) ? '' :  */ selectMilestoneId,
      // current_milestone_id: projectDetailData?.current_milestone_id,
    });
  }, [selectMilestone, projectDetailData]);

  useEffect(() => {
    if (!selectCategory) return;
    setAddDataList(null);
    setContentLoading(true);
    setAddDataCardStatusList([]);
  }, [selectCategory]);

  // 判断Add Updates按钮是否要禁用
  /* useEffect(() => {
    if (defaultDataConfirmAccessList?.length || addDataConfirmAccessList?.length) {
      let flag1 = true, flag2 = true;
      if (defaultDataConfirmAccessList?.length) {
        flag1 = defaultDataConfirmAccessList?.every((t: boolean) => t);
      }
      if (addDataConfirmAccessList?.length) {
        flag2 = addDataConfirmAccessList?.every((t: boolean) => t);
      }
      setDisabledAddBtn(!flag1 || !flag2);
    }
  }, [defaultDataConfirmAccessList, addDataConfirmAccessList]); */

  // 接口数据返回后，数据处理
  useEffect(() => {
    if (projectUpdateLoading) return;
    const data = projectUpdateList?.data?.data;
    if (Array.isArray(data)) {
      // 之前的completed处理成现在对应的status
      const orgData = data?.map((t) => {
        const content = t?.content
          ? {
            ...t?.content,
            risks: handleRisksCategory(t?.content?.new_risks),
            workplans: handleWorkplansRes(t?.content?.workplans),
          }
          : t?.content;

        return { ...t, content };
      });
      setDataList(orgData);

      {
        /*/ / REMARK: 参考 src/pages/Pipeline/ProjectDetails/ProjectUpdate/index.tsx文件头部的注释解释1
      // 当milestone是当前阶段时，顶部progress标签同步最新状态
      if ((selectMilestone === projectDetailData?.current_milestone) && orgData?.[0]?.progress) {
        setProgress(orgData?.[0]?.progress);
      }*/
      }

      // 判断各模块卡片编辑态Confirm按钮是否可用
      const v: boolean[] = [];
      const _accessList =
        orgData?.map((t: any) => {
          v.push(false);

          {
            /*/ / REMARK: 参考 src/pages/Pipeline/ProjectDetails/ProjectUpdate/index.tsx文件头部的注释解释1
        return (t?.date && t?.progress) ? true : false;*/
          }

          return !!t?.date;
        }) || [];
      setDefaultDataConfirmAccessList(_accessList);
      setDefaultDataCardStatusList(v);
    }
    projectUpdateList?.data && setIsInit(false);
    // tab切换时，根据接口返回，初始化找到有数据的Milestone
    /* if (!filter?.milestone && !filterObj?.projectUpdateInitMilestone && isInit && projectUpdateList?.data?.req && Array.isArray(milestones)) {
      let _selectMilestone = '';
      // 找到有数据的Milestone对应的名称，告诉筛选器去选中这个Milestone
      for (let i = 0; i < milestones?.length; i ++) {
        const t = milestones?.[i];
        if (t?.milestone_id === projectUpdateList?.data?.req) {
          _selectMilestone = t?.milestone;
        }
      }
      _selectMilestone && setSelectMilestone([_selectMilestone]);
      setIsResponseMilestone(true);
      filterRef?.current?.setFormModel({
        milestone: [_selectMilestone],
        lastSelectMilestone: [_selectMilestone],
      });
    } */
  }, [projectUpdateLoading]);

  useEffect(() => {
    const { milestone } = filter || {};
    const locationMilestone = filterObj?.projectUpdateInitMilestone;
    // 获取在product info页面 保存的milestones后，清空状态管理中保存的milestone，避免 projectUpdate页面始终 用 跳转前点击的milestone初始化数据
    dispatch({ type: `${GAME_DETAIL_TAB_DATA_MODEL_NAMESPACE}/clearFilter` });
    // milestone有值，说明是详情页点击对应的milestone跳转过来的，这时选中对应的milestone
    milestone && setSelectMilestone([milestone]);
    locationMilestone && setSelectMilestone([locationMilestone]); // 地址栏的，链接跳转过来时
    if (!milestone && !locationMilestone) setSelectMilestone([]); // 全选
    // setIsResponseMilestone(false);

    {
      /*/ / REMARK: 参考 src/pages/Pipeline/ProjectDetails/ProjectUpdate/index.tsx文件头部的注释解释1
    // 是当前milstone且之前状态管理里的progress没有值，储存下progress，按道理这种情况一般不会发生
    if ((selectMilestone === projectDetailData?.current_milestone) && !progress) {
      setProgress(projectDetailData?.progress);
    }*/
    }
  }, [projectDetailData]);

  useEffect(() => {
    setContentLoading(projectUpdateLoading);
  }, [projectUpdateLoading]);
  // #endregion

  // #region Full Action Items List页面相关
  // const [isInitActionItemsList, setIsInitActionItemsList] = useState<boolean>(true);
  const [initReqLoading, setInitReqLoading] = useState<boolean>(false);
  const [selectDate, setSelectDate] = useState<[string, string]>(['', '']);
  const [actionItemsListDataTimeRange, setActionItemsListDataTimeRange] = useState<
  [string, string]
  >(['', '']);
  const [downloadParams, setDownloadParams] = useState<IactionItemsListDownloadParams>(
    ACTION_ITEMS_LIST_DEFAULT_DOWNLOAD_PARAMS,
  );
  const [isStopReq, setIsStopReq] = useState<boolean>(false); // 重置时阻止请求接口

  const {
    loading: queryActionItemsLoading,
    data: queryActionItemsData,
    run: queryActionItemsRun,
    runAsync: queryActionItemsRunAsync,
  } = useRequest(queryActionItemsList, { manual: true });

  const reset = useMemoizedFn(() => {
    setInitReqLoading(false);
    setSelectDate(['', '']);
    setActionItemsListDataTimeRange(['', '']);
    setDownloadParams(ACTION_ITEMS_LIST_DEFAULT_DOWNLOAD_PARAMS);
    setIsStopReq(true);
  });

  const handleActionItemsListFilterChange = useMemoizedFn(
    (data: { startDate: string; endDate: string; }) => {
      const { startDate, endDate } = data;
      setSelectDate([startDate, endDate]);
      setDownloadParams({
        ...downloadParams,
        selectDate: [startDate, endDate],
      });
      queryActionItemsRun({
        project_id: projectDetailData?.project_id,
        start_date: startDate,
        end_date: endDate,
        order: downloadParams?.sorts?.order as 'asc' | 'desc',
      });
      setIsStopReq(false);
    },
  );

  const handleConfirm = useMemoizedFn(async () => {
    setSubmitted(true);
    const projectUpdate = updateProjectEditForm?.current?.getData();
    if (!editValid) return;
    try {
      setEditLoading(true);
      const projectUpdateContent = projectUpdate?.content;
      const content: Record<string, any> = {
        ...projectUpdateContent,
        workplans: getValidActionItems(projectUpdateContent?.workplans),
        new_risks: getValidList(projectUpdateContent?.risks),
      };
      delete content.risks;
      let params = {
        project_id: projectDetailData?.project_id,
        date: projectUpdate?.date || '',
        granularity: projectUpdate?.granularity || 2,
        content: JSON.stringify(content),
        gr_action_milestone_id: projectUpdate?.gr_action_milestone_id || '',
        gr_action_milestone: projectUpdate?.gr_action_milestone || '',
        gr_action: projectUpdate?.gr_action || [],
        material: projectUpdate?.material || [],
      };
      if (mode === 'edit') {
        params = {
          ...params,
          // @ts-ignore
          id: projectUpdate?.id,
          // @ts-ignore
          update_id: projectUpdate?.update_id,
        };
      }
      const res = await editProjectUpdate(params as any);
      if (res?.status !== 200 || res?.data?.code !== 200) throw new Error('');
      if (mode === 'add') {
        setAddDataList?.(null);
        // @ts-ignore
        reportOperationLog(ALL_REPORT_OPERATION_LOG.DETAIL_PROJECT_UPDATE_ADD_SUBMIT, 'button');
      } else if (mode === 'edit') {
        // @ts-ignore
        reportOperationLog(ALL_REPORT_OPERATION_LOG.DETAIL_PROJECT_UPDATE_EDIT_SUBMIT, 'button');
      }
      deleteSaveParamsByPageKey(pageKeyCur);
      // 重新请求数据
      resetQueryList(mode as any);
      resetAddEditData();
      onRefreshProjectDetails?.();
      onRefreshMilestones?.();

      if (Array.isArray(deletePathList) && deletePathList?.length > 0) {
        deleteFileFun();
      }
    } catch (exception) {
      messageTips('error', 'Save failed. Please check the network');
    } finally {
      setEditLoading(false);
      setSubmitted(false);
    }
  });

  const [editAutoSaveData, setEditAutoSaveData] = useState(currentEditList);
  const [autoSaveVisible, setAutoSaveVisible] = useState(false);

  const pageKeyCur = useMemo(() => {
    if (mode === 'edit') {
      return `${EDIT_PAGE_KEY_MAP.pipeline_gameDetails_update_info_edit}_${projectDetailData?.project_id}_${currentEditList?.update_id}`;
    }
    return `${EDIT_PAGE_KEY_MAP.pipeline_gameDetails_update_info_add}_${projectDetailData?.project_id}`;
  }, [mode, currentEditList, projectDetailData?.update_id]);

  useDeepCompareEffect(() => {
    setEditAutoSaveData(currentEditList);
  }, [currentEditList]);

  // 自动保存hooks
  const { getSaveParamsValue, showRestorePrompt, deleteSaveParamsByPageKey } = useAutoSaveParams({
    pageKey: pageKeyCur,
  });

  const handleAutoSaveConfirm = () => {
    const saveObj = getSaveParamsValue(pageKeyCur) || {};
    setEditAutoSaveData({
      ...currentEditList,
      ...saveObj,
    });
    setAutoSaveVisible(false);
    setEditModalVisible(true);
  };

  const handleAutoSaveCancel = () => {
    deleteSaveParamsByPageKey(pageKeyCur);
    setEditAutoSaveData(currentEditList);
    setAutoSaveVisible(false);
    setEditModalVisible(true);
  };

  const editItemHandle = (item: any) => {
    // 如果有自动保存过的，先咨询
    if (
      showRestorePrompt(
        `${EDIT_PAGE_KEY_MAP.pipeline_gameDetails_update_info_edit}_${projectDetailData?.project_id}_${item?.update_id}`,
      )
    ) {
      setAutoSaveVisible(true);
    } else {
      setEditModalVisible(true);
    }
  };

  const projectUpdateListNode = useRef<HTMLDivElement | null>(null);

  const handleActionItemEdit = useMemoizedFn((cvm: any) => {
    const dataItemIdx = dataList?.findIndex(
      (item: any) =>
        String(item?.granularity) === String(cvm?.granularity) && item?.date === cvm?.date,
    );
    if (dataItemIdx !== -1) {
      const maxLen = getMaxLength(selectCategory);
      const dataItem = dataList?.[dataItemIdx];
      if (dataItemIdx >= maxLen) {
        setSelectCategory('all');
        setAllVisible();
      }
      setSegmentValue(SEGMENT_UPDATE_INFO);
      setTimeout(() => {
        scrollUpdatesCardIntoView(pageContainer, dataItemIdx);
        setMode('edit');
        setCurrentEditList(dataItem);

        // 如果有自动保存过的，先咨询
        if (
          showRestorePrompt(
            `${EDIT_PAGE_KEY_MAP.pipeline_gameDetails_update_info_edit}_${projectDetailData?.project_id}_${dataItem?.update_id}`,
          )
        ) {
          setAutoSaveVisible(true);
        } else {
          setEditModalVisible(true);
        }

        // setEditModalVisible(true);
      }, AUTO_SCROLL_WAITTING);
    }
  });

  // 首次请求获取全部数据，并确定筛选器时间范围
  useAsyncEffect(async () => {
    if (segmentValue === SEGMENT_ACTION_ITEMS_LIST /* && isInitActionItemsList */) {
      // setIsInitActionItemsList(false);
      setInitReqLoading(true);
      try {
        const res = await queryActionItemsRunAsync({
          project_id: projectDetailData?.project_id,
          start_date: '',
          end_date: '',
          order: 'asc',
        });
        const startDate = res?.data?.req?.start_date || '';
        const endDate = res?.data?.req?.end_date || '';
        // 可选日期范围整理成起始月的第一天，结束月的最后一天
        if (moment(startDate).isValid() && moment(endDate).isValid()) {
          const d1 = moment(startDate).startOf('month').format('YYYY-MM-DD');
          const d2 = moment(endDate).endOf('month').format('YYYY-MM-DD');
          setActionItemsListDataTimeRange([d1, d2]);
        }
        setSelectDate([startDate, endDate]);
        setDownloadParams({
          ...downloadParams,
          selectDate: [startDate, endDate],
        });
      } catch (error) {
        throw error;
      } finally {
        setInitReqLoading(false);
        setIsStopReq(false);
      }
    } else {
      reset();
    }
  }, [segmentValue]);

  // 排序发生改变及页签切换到Full Action Items List时请求接口
  useUpdateEffect(() => {
    if (isStopReq) {
      setIsStopReq(false);
      return;
    }
    queryActionItemsRun({
      project_id: projectDetailData?.project_id,
      start_date: selectDate?.[0],
      end_date: selectDate?.[1],
      order: downloadParams?.sorts?.order as 'asc' | 'desc',
    });
  }, [downloadParams?.sorts?.order]);
  // #endregion

  const getClose = async () => {
    resetAddEditData();
  };

  const loadingContainer = useRef<HTMLDivElement>(null);
  const { visibleLength, dataListNew, setAllVisible } = useLoadMoreUpdates({
    pageContainer,
    loadingContainer,
    userIsAbleSee,
    segmentValue,
    contentLoading,
    dataList,
  });

  useAutoScroll2Target({
    pageContainer,
    segment: segmentValue,
    loading: projectUpdateLoading,
    dataList,
    projectUpdateListNode,
    setAllVisible,
    setSelectCategory,
  });

  return (
    <context.Provider
      value={{
        userIsAbleEdit,
        projectDetailData,
        milestones,
        // selectMilestone,
        selectMilestoneId,
      }}
    >
      <>
        <div className="dbg-detail-project-update-flex">
          <div className="dbg-detail-project-update-left">
            <Segment
              className="dbg-detail-project-update-segment  segment-light"
              value={segmentValue}
              options={[
                {
                  text: 'Update Info',
                  value: SEGMENT_UPDATE_INFO,
                },
                {
                  text: (
                    <Bubble
                      className="dbg-segment-clonse-bubble"
                      visible={
                        segmentGuideLoading || isCompletedSegmentGuide ? false : bubbleVisible
                      }
                      overlayClassName="dbg-segment-clonse-bubble-overlay"
                      // popupContainer={()=>{(document.getElementsByClassName('.dbg-detail-project-update-segment')|| document.body)}}
                      dark
                      // positionFixed={false}
                      placementOffset={[0, 20]}
                      content={
                        <div className="dbg-segment-clonse">
                          {/* Only a list of action items can be viewed by clicking here!*/}
                          View all action items
                          <HomeSvgIcon
                            className="dbg-segment-clonse-icon"
                            type="clonse"
                            // eslint-disable-next-line @typescript-eslint/no-misused-promises
                            onClick={handleClickCloseGuide}
                          />
                        </div>
                      }
                    >
                      Full Action Items List
                    </Bubble>
                  ),
                  value: SEGMENT_ACTION_ITEMS_LIST,
                },
              ]}
              onChange={(value: '1' | '2') => {
                if (value === SEGMENT_UPDATE_INFO) {
                  setTimeout(() => {
                    filterRef?.current?.setFormModel({
                      category: selectCategory,
                    });
                  });
                }
                setSegmentValue(value);
              }}
            />
          </div>
          <div className="dbg-detail-project-update-right">
            {segmentValue === SEGMENT_UPDATE_INFO ? (
              (!contentLoading || !isInit) && (
                <Filter
                  ref={filterRef}
                  className="dbg-detail-project-update-filter "
                  defaultCategory={selectCategory}
                  defaultMilestone={selectMilestone}
                  onAdd={handleFilterAdd}
                  onChange={handleFilterChange}
                  isAddBtnDisabled={disabledAddBtn}
                  isDownloadBtnDisabled={!dataList?.length}
                  setFormModelMilestone={setFormModelMilestone}
                />
              )
            ) : (
              <ActionItemsFilter
                loading={initReqLoading}
                dateRange={actionItemsListDataTimeRange}
                isDownloadBtnDisabled={!queryActionItemsData?.data?.data?.workplans?.length}
                onChange={handleActionItemsListFilterChange}
                downloadParams={downloadParams}
              />
            )}
          </div>
        </div>

        {/* Update Info */}
        {segmentValue === SEGMENT_UPDATE_INFO && (
          <div ref={projectUpdateListNode} className="dbg-detail-project-update-content">
            {contentLoading && <Loading style={{ height: 'calc(100vh - 400px)' }} loading />}
            {contentLoading ||
              dataListNew?.map((t: any, i: number) => {
                const maxLen = getMaxLength(selectCategory);
                return i < maxLen || selectCategory === 'all' ? (
                  <ProjectUpdateCard
                    key={t?.date + i}
                    operationable={userIsAbleEdit}
                    position={i}
                    type="default"
                    itemList={t}
                    selectedUpdationDates={selectedUpdationDates}
                    userIsAbleEdit={userIsAbleEdit}
                    handleDeleteCard={handleDeleteCard}
                    defaultDataConfirmAccessList={defaultDataConfirmAccessList}
                    setDefaultDataConfirmAccessList={setDefaultDataConfirmAccessList}
                    defaultDataCardStatusList={defaultDataCardStatusList}
                    setDefaultDataCardStatusList={setDefaultDataCardStatusList}
                    removeAddListLastItem={removeAddListLastItem}
                    resetQueryList={resetQueryList}
                    setMode={setMode}
                    setCurrentEditList={setCurrentEditList}
                    setEditModalVisible={setEditModalVisible}
                    editItemHandle={editItemHandle}
                  />
                ) : null;
              })}
            {!contentLoading && !dataList?.length && (
              <div className="dbg-detail-project-update-content-nodata">
                <NoData
                  className="font14"
                  // constomStyle={{ position: 'absolute' }}
                />
              </div>
            )}
            {!contentLoading && dataList?.length > visibleLength && (
              <Loading
                ref={loadingContainer}
                className="dbg-project-details-footer-loading"
                style={{ height: 40 }}
                loading
              />
            )}
          </div>
        )}
        {/* Full Action Items List */}
        {segmentValue === SEGMENT_ACTION_ITEMS_LIST && (
          <div className="gp-detail-project-update-action-items-content">
            <ActionItemsList
              loading={queryActionItemsLoading || initReqLoading}
              userIsAbleEdit={userIsAbleEdit}
              data={queryActionItemsData?.data?.data || null}
              downloadParams={downloadParams}
              setDownloadParams={setDownloadParams}
              hideHeader={hideHeader}
              onEdit={handleActionItemEdit}
            />
          </div>
        )}

        {/* 增加编辑弹窗 */}
        <GeneralModal
          visible={editModalVisible}
          isFont14
          title="Update Info"
          className="dbg-general-project-edit-modal"
          modalSize="auto"
          content={
            <UpdateProjectEditForm
              ref={updateProjectEditForm}
              isEntryEdit={editModalVisible}
              mode={mode}
              dataList={dataList}
              data={editAutoSaveData}
              initialParams={currentEditList}
              setEditAvailable={setEditAvailable}
              setEditValid={setEditValid}
              submitted={submitted}
              editValid={editValid}
              pageKeyCur={pageKeyCur}
              setIsCompletedVideo={setIsCompletedVideo}
              actionItemCategory={actionItemCategory}
              setDeletePathList={setDeletePathList}
              deletePathList={deletePathList}
            />
          }
          isFooter
          loadingConfirm={editLoading}
          disabledConfirm={!editAvailable || !isCompletedVideo}
          onConfirm={handleConfirm}
          onClose={() => {
            deleteSaveParamsByPageKey(pageKeyCur);
            getClose();
          }}
        />
        {/* 咨询自动保存弹窗 */}
        <AutoSaveModal
          visible={autoSaveVisible}
          onConfirm={handleAutoSaveConfirm}
          onClose={handleAutoSaveCancel}
        />
      </>
    </context.Provider>
  );
};

export default React.memo(ProjectUpdate);
